import { useDialog } from 'modules/common/hooks/useDialog';

interface UseAddNetworkDialogProps {
  onOpen?: () => void;
}

export const useAddNetworkDialog = ({
  onOpen: onOpenExternal,
}: UseAddNetworkDialogProps = {}) => {
  const {
    isOpened: isAddNetworkDialogOpened,
    onClose: closeAddNetworkDialog,
    onOpen,
  } = useDialog();

  const openAddNetworkDialog = () => {
    if (onOpenExternal) {
      onOpenExternal();
    } else {
      onOpen?.();
    }
  };

  return {
    closeAddNetworkDialog,
    isAddNetworkDialogOpened,
    openAddNetworkDialog,
  };
};
